import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'

import Config from "../../Config.jsx"
import Localization from "../../Localization.jsx"
import SubmissionDetailAnswer from "./SubmissionDetailAnswer.jsx"
import PinDropIcon from '@mui/icons-material/PinDrop';
import Typography from '@mui/material/Typography';

import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Switch,
  FormControlLabel,
  List,
} from '@mui/material';

class SubmissionDetailHotspot extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      hotspotData: this.props.hotspotData,
      answerDataList: props.answerDataList,
      showAllAnswers: false,
    };
    autoBind(this);
  }

  getComponentById(componentId) {
    // console.log("componentId: " + componentId);
    // console.log("this state hotspot data: " + JSON.stringify(this.state.hotspotData));
    let componentList = this.state.hotspotData['component_list'];
    // console.log("componentList: " + JSON.stringify(componentList));
    for (let i = 0; i < componentList.length; i++) {
      if (componentList[i].id == componentId) {
        return componentList[i];
      }
    }

    return null;
  }

  render() {
    var showViewMore = false;

    return (
      <div>
        <Card style={{margin:"16px 4px"}}>
          <CardHeader
            title={
              <div style={{ display: 'flex', alignItems: 'flex-start' }}>
              <PinDropIcon style={{ color: '#CCC', marginRight: '8px', marginTop: '4px' }} />
              <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                {this.state.hotspotData['name']}
              </Typography>
              </div>
            }
            subheader={
              <If condition={showViewMore}>
                <Then>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={this.state.showAllAnswers}
                        onChange={this.onShowAllToggle}
                      />
                    }
                    label={Localization.strings.SHOW_ALL_ATTEMPTS}
                  />
                </Then>
              </If>
            }
          />
          <CardContent>
            <If condition={this.state.answerDataList.length == 0}>
              <Then>
                <Divider/>
                <br/>
                {Localization.strings.NO_ANSWER}
              </Then>
              <Else>
                {this.state.answerDataList.filter( (row) => {
                  return this.getComponentById(row.component_id) != null && row.kind >= Config.HOTSPOT_CONTENT_MC_OF_TEXTS;
                }).map( (row, i) => {
                  return [
                    <Divider key={'divider-' + row['id']}/>,
                    <List key={'list-' + row['id']}>
                      <SubmissionDetailAnswer parent={this} root={this.props.root}
                        componentData={this.getComponentById(row.component_id)}
                        answerData={row}
                        submission={this.props.submission}
                        showCompareButton={!this.props.isSharedView}
                        isSharedView={this.props.isSharedView}
                        showUserName={false}
                        key={row['id']}
                      />
                    </List>,
                  ];
                })}
              </Else>
            </If>
          </CardContent>
        </Card>
      </div>
    )
  }
}

export default SubmissionDetailHotspot;
